import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'semantic-ui-react';

import ReturnInvoices from './ReturnInvoices';
import CanceledReturnInvoices from './CanceledReturnInvoices';
import GuaranteePanel from '../components/GuaranteePanel';
import ProductSelector from '../components/ProductSelector';
import { GUARANTEE_PRODUCT_LIST, PRODUCT_FAMILY_PAGE_OFFSET_STYLE } from '../constants/productFamily';
import {
  useResetReturnInvoicesProductFamilyOnExit,
  useReturnInvoicesProductFamily,
  useReturnInvoicesProductFamilyTheme,
} from '../hooks/useReturnInvoicesProductFamily';

const panes = [
  {
    menuItem: 'Return Invoices',
    render: () => (
      <Tab.Pane>
        {' '}
        <ReturnInvoices />
      </Tab.Pane>
    ),
  },
  {
    menuItem: 'Canceled Return Invoices',
    render: () => (
      <Tab.Pane>
        <CanceledReturnInvoices />
      </Tab.Pane>
    ),
  },
];

const ReturnInvoicesProductSelector = () => {
  const [selectedProduct, handleProductChange] = useReturnInvoicesProductFamily();
  const themeClass = useReturnInvoicesProductFamilyTheme();

  return (
    <ProductSelector
      products={GUARANTEE_PRODUCT_LIST}
      selectedProduct={selectedProduct}
      onProductChange={handleProductChange}
      tooltipContent='Select the product to filter return invoices.'
      themeClass={themeClass}
    />
  );
};

const ReturnInvoicesTheme = ({ children }) => {
  const themeClass = useReturnInvoicesProductFamilyTheme();
  return (
    <div data-testid='return-invoices-theme' className={`theme ${themeClass}`} style={PRODUCT_FAMILY_PAGE_OFFSET_STYLE}>
      {children}
    </div>
  );
};

ReturnInvoicesTheme.propTypes = {
  children: PropTypes.node.isRequired,
};

const ReturnInvoicesTabs = () => {
  useResetReturnInvoicesProductFamilyOnExit();
  return (
    <ReturnInvoicesTheme>
      <GuaranteePanel>
        <ReturnInvoicesProductSelector />
      </GuaranteePanel>
      {' '}
      <Tab panes={panes} />
    </ReturnInvoicesTheme>
  );
};

export default ReturnInvoicesTabs;
